module.exports = __webpack_public_path__ + "static/media/profile_bg1.97146142.jpg";